import { useRive, Layout, Fit, Alignment } from '@rive-app/react-canvas';

import { RiveAssets } from '@core/rive_assets';

export function Signature({ reversed }: SignatureProps): JSX.Element {
  const { RiveComponent: Animation } = useRive({
    src: reversed ? RiveAssets.signatureBlack : RiveAssets.signatureWhite,
    layout: new Layout({
      fit: Fit.Contain,
      alignment: Alignment.Center,
    }),
    autoplay: true,
  });

  return (
    <div className="signature">
      <Animation />
    </div>
  );
}
